import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    available: [...construction.available.first_height],
    info: construction.info.first_height,
    loaded: construction.parameters_loaded,
    selected: construction.selected.first_height
  })
);
